export default "__VITE_ASSET__opPqUH1V__"